// Products injected by Liquid — see sections/elya-home.liquid


// ── i18n ──────────────────────────────────────────────────────────────
const T={
  de:{addToCart:'In den Warenkorb',inCartBtn:'In den Warenkorb —',eyebrow:'Nouvelle Collection — 2026',heroSub:'Von Dita bis Cazal.<br>Die seltensten Sonnenbrillen der Welt.',cta1:'Kollektion',cta2:'Über ELYA',shopOver:'Kollektion',catAll:'Alle',catSun:'Sonnenbrillen',catOpt:'Brillen',quote:'„Luxus ist die Freiheit, <b>das Beste</b> zu wählen.\"',aboutOver:'Das Haus ELYA',aboutH:'Jedes Stück<br>erzählt eine<br><em>Geschichte.</em>',aboutP:'ELYA kuratiert die begehrtesten Sonnenbrillen der Welt. Authentisch geprüft, diskret geliefert. Luxus ist keine Frage des Preises — sondern der Haltung.',footerTagline:'Kuratierte Luxus-Eyewear. Authentisch. Berlin.',cartTitle:'Warenkorb',shipping:'Versand',free:'Kostenlos',checkout:'Zur Kasse →',continueShopping:'Weiter einkaufen',escHint:'ESC — Schließen',filterTitle:'Filter',filterBrand:'Marke',filterSort:'Sortierung',sortDefault:'Standard',apply:'Anwenden',searchPlaceholder:'Maison oder Modell…'},
  en:{addToCart:'Add to Cart',inCartBtn:'Add to Cart —',eyebrow:'New Collection — 2026',heroSub:'From Dita to Cazal.<br>The rarest sunglasses in the world.',cta1:'Collection',cta2:'About ELYA',shopOver:'Collection',catAll:'All',catSun:'Sunglasses',catOpt:'Eyeglasses',quote:'"Luxury is the freedom to <b>choose the best</b>."',aboutOver:'The House of ELYA',aboutH:'Every piece<br>tells a<br><em>story.</em>',aboutP:'ELYA curates the most coveted sunglasses in the world. Authentically verified, discreetly delivered. Luxury is not a matter of price — but of attitude.',footerTagline:'Curated Luxury Eyewear. Authentic. Berlin.',cartTitle:'Cart',shipping:'Shipping',free:'Free',checkout:'Checkout →',continueShopping:'Continue Shopping',escHint:'ESC — Close',filterTitle:'Filter',filterBrand:'Brand',filterSort:'Sort By',sortDefault:'Default',apply:'Apply',searchPlaceholder:'Brand or model…'},
};
let lang = (typeof localStorage !== 'undefined' && localStorage.getItem('elya-lang')) || 'de';
function t(key){ return T[lang][key] || T.de[key] || key; }

// ── State ─────────────────────────────────────────────────────────────
let cart=[],cat='all',brand='',sort='',gender='';
const $=id=>document.getElementById(id);
const fmt=n=>n.toLocaleString('de-DE',{style:'currency',currency:'EUR'});

// ── Init ──────────────────────────────────────────────────────────────
window.addEventListener('load',()=>{
  applyLang();
  const spans=document.querySelectorAll('#ldr-word span');
  spans.forEach((s,i)=>setTimeout(()=>s.style.transform='translateY(0)',i*100));
  setTimeout(()=>{const L=$('ldr');L.style.transition='opacity .75s';L.style.opacity='0';setTimeout(()=>{L.style.display='none';heroIn()},750)},1700);
});

function heroIn(){
  const e=$('hte');if(e)e.style.opacity='1';
  document.querySelectorAll('#hth .row span').forEach((s,i)=>setTimeout(()=>s.style.transform='translateY(0)',200+i*150));
  setTimeout(()=>{const el=$('hts');if(el)el.style.opacity='1'},700);
  setTimeout(()=>{const el=$('htc');if(el)el.style.opacity='1'},950);
  setTimeout(()=>{const el=$('hsc');if(el)el.classList.add('on')},1400);
}

function onScroll(){
  const sy=window.scrollY;
  const hbg=$('hbg');if(hbg)hbg.style.transform=`translateY(${sy*0.35}px)`;
  const qs=$('quote');
  if(qs){const r=qs.getBoundingClientRect();const qb=$('qbg');if(qb)qb.style.transform=`translateY(${(window.innerHeight*.5-r.top-r.height*.5)*0.28}px)`}
  const nav=$('nav');if(nav)nav.classList.toggle('s',sy>40);
}
window.addEventListener('scroll',onScroll,{passive:true});
onScroll();

const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}}),{threshold:.1,rootMargin:'0px 0px -30px 0px'});
document.querySelectorAll('.fade').forEach(el=>io.observe(el));

// ── Language ──────────────────────────────────────────────────────────
function applyLang(){
  document.querySelectorAll('[data-i18n]').forEach(el=>{
    const key=el.getAttribute('data-i18n');
    const val=t(key);
    if(val)el.innerHTML=val;
  });
  const si=$('sin');if(si)si.placeholder=t('searchPlaceholder');
  const lb=$('lang-btn');if(lb)lb.textContent=lang.toUpperCase();
  document.querySelectorAll('.lang-item').forEach(i=>{
    i.classList.toggle('active',i.textContent.trim().toLowerCase().startsWith(lang));
  });
  render();
}

function setLang(l){
  lang=l;
  try{localStorage.setItem('elya-lang',l);}catch(e){}
  applyLang();
  $('lang-menu').classList.remove('open');
}

function toggleLang(){
  $('lang-menu').classList.toggle('open');
}

// ── Custom Dropdowns ──────────────────────────────────────────────────
function toggleDd(id){
  const menu=$(id);
  const isOpen=menu.classList.contains('open');
  document.querySelectorAll('.cdd-menu').forEach(m=>m.classList.remove('open'));
  if(!isOpen)menu.classList.add('open');
}
function pickBrand(val,label,el){
  brand=val;
  document.querySelectorAll('#dd-brand .cdd-item').forEach(i=>i.classList.remove('sel'));
  el.classList.add('sel');
  $('dd-brand-btn').textContent=label;
  $('dd-brand').classList.remove('open');
  render();
}
function pickSort(val,label,el){
  if(val==='her'||val==='him'){
    gender=val;
    sort='';
    document.querySelectorAll('#dd-sort .cdd-item').forEach(i=>i.classList.remove('sel'));
    el.classList.add('sel');
    $('dd-sort-btn').textContent=label;
    $('dd-sort').classList.remove('open');
  } else if(val==='all-gender'){
    gender='';
    sort='';
    document.querySelectorAll('#dd-sort .cdd-item').forEach(i=>i.classList.remove('sel'));
    el.classList.add('sel');
    $('dd-sort-btn').textContent=label;
    $('dd-sort').classList.remove('open');
  } else {
    sort=val;
    document.querySelectorAll('#dd-sort .cdd-item').forEach(i=>i.classList.remove('sel'));
    el.classList.add('sel');
    $('dd-sort-btn').textContent=label;
    $('dd-sort').classList.remove('open');
  }
  render();
}

// ── Filters & Render ─────────────────────────────────────────────────
function getP(){
  let r=[...P];
  if(cat==='new')r=r.filter(x=>x.flag==='new');
  else if(cat==='sale')r=r.filter(x=>x.flag==='sale'||x.cat==='sale');
  else if(cat!=='all')r=r.filter(x=>x.cat===cat);
  if(brand)r=r.filter(x=>x.b===brand);
  if(gender==='her')r=r.filter(x=>x.gender==='her'||x.gender==='unisex');
  else if(gender==='him')r=r.filter(x=>x.gender==='him'||x.gender==='unisex');
  if(sort==='asc')r.sort((a,b)=>a.price-b.price);
  else if(sort==='desc')r.sort((a,b)=>b.price-a.price);
  return r;
}

function render(){
  const g=$('grid');
  if(!g)return;
  const addLabel=t('addToCart');
  g.innerHTML=getP().map(p=>`<div class="card" onclick="openDrw(${p.id})"><div class="ci"><img class="img1" src="${p.img}" alt="${p.n}" loading="lazy">${p.img2?`<img class="img2" src="${p.img2}" alt="${p.n}" loading="lazy">`:''}${p.flag?`<span class="tag ${p.flag==='new'?'tn':'ts'}">${p.flag==='new'?'Nouveau':'Sale'}</span>`:''}<button class="qadd" onclick="addC(event,${p.id})">${addLabel}</button></div><div class="cb"><div class="cb-b">${p.b}</div><div class="cb-n">${p.n}</div><div class="cb-r">${p.ref}</div><div class="cb-p">${fmt(p.price)}${p.orig?`<span class="cb-o">${fmt(p.orig)}</span>`:''}</div></div></div>`).join('');
  requestAnimationFrame(()=>g.querySelectorAll('.card').forEach((c,i)=>setTimeout(()=>c.classList.add('in'),i*42)));
}

function setCat(c,btn){
  cat=c;
  document.querySelectorAll('.ft').forEach(b=>b.classList.remove('on'));
  if(btn)btn.classList.add('on');
  const grid=$('grid');
  const panel=$('private-panel');
  const plBanner=$('preloved-banner');
  if(c==='private'){
    if(grid)grid.style.display='none';
    if(panel)panel.style.display='block';
    if(plBanner)plBanner.style.display='none';
  } else {
    if(grid)grid.style.display='';
    if(panel)panel.style.display='none';
    if(plBanner)plBanner.style.display=(c==='preloved')?'flex':'none';
    render();
  }
  $('shop').scrollIntoView({behavior:'smooth',block:'start'});
}
function setBrand(v){brand=v;render()}
function setSort(v){sort=v;render()}

// ── Product Drawer ────────────────────────────────────────────────────
function openDrw(id){
  const p=P.find(x=>x.id===id);
  $('dp').innerHTML=`<div class="dh"><span class="dh-b">${p.b}</span><button class="xb" onclick="closeDrw()">×</button></div><img class="d-img" src="${p.img}" alt="${p.n}"><div class="d-body"><div class="d-name">${p.n}</div><div class="d-ref">${p.ref}</div><div class="d-price">${fmt(p.price)}</div>${p.orig?`<div class="d-orig">${fmt(p.orig)}</div>`:''}<div class="d-hr"></div><div class="d-desc">${p.desc}</div><div class="d-lbl">Details</div>${Object.entries(p.specs).map(([k,v])=>`<div class="d-row"><span class="dk">${k}</span><span class="dv">${v}</span></div>`).join('')}<button class="d-add" onclick="addCFromDrw(${p.id})">${t('inCartBtn')} ${fmt(p.price)}</button></div>`;
  $('drw').classList.add('on');document.body.style.overflow='hidden';
}
function closeDrw(){$('drw').classList.remove('on');document.body.style.overflow=''}
function addCFromDrw(id){addToCart(id);closeDrw()}
function addC(e,id){e.stopPropagation();addToCart(id)}
function addToCart(id){const p=P.find(x=>x.id===id),ex=cart.find(x=>x.id===id);if(ex)ex.q++;else cart.push({...p,q:1});updBadge();renderCart();toast(`${p.b} — ${p.n}`);openCart()}
function removeC(id){cart=cart.filter(x=>x.id!==id);updBadge();renderCart()}
function updBadge(){const n=cart.reduce((s,i)=>s+i.q,0);const b=$('bc');b.textContent=n;b.classList.toggle('on',n>0)}
function renderCart(){
  const body=$('cbody'),ft=$('cft');
  if(!cart.length){body.innerHTML='<div class="cempty">Leer.</div>';ft.style.display='none';return}
  const sub=cart.reduce((s,i)=>s+i.price*i.q,0);
  body.innerHTML=cart.map(i=>`<div class="ci2"><img class="ci2-img" src="${i.img}"><div style="flex:1"><div class="ci2-b">${i.b}</div><div class="ci2-n">${i.n}</div><div class="ci2-p">${fmt(i.price)} × ${i.q}</div></div><button class="ci2-x" onclick="removeC(${i.id})">×</button></div>`).join('');
  $('csub').textContent=fmt(sub);$('ctot').textContent=fmt(sub);ft.style.display='block';
}
function openCart(){$('cart').classList.add('on');document.body.style.overflow='hidden';renderCart()}
function closeCart(){$('cart').classList.remove('on');document.body.style.overflow=''}

// ── Shopify Checkout ──────────────────────────────────────────────────
async function openCo(){
  if(!cart.length)return;
  closeCart();
  toast(lang==='en'?'Redirecting to checkout…':'Weiterleitung zum Checkout…');
  try{
    const items=cart.map(i=>({id:parseInt(i.shopifyId),quantity:i.q}));
    const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
    if(res.ok){window.location.href='/checkout';}
    else{toast(lang==='en'?'Error. Please try again.':'Fehler. Bitte erneut versuchen.');}
  }catch(e){console.error(e);toast(lang==='en'?'Connection error.':'Verbindungsfehler.');}
}

// ── Search ────────────────────────────────────────────────────────────
function toggleSrch(){const s=$('srch');s.classList.toggle('on');if(s.classList.contains('on')){setTimeout(()=>$('sin').focus(),80);document.body.style.overflow='hidden'}else document.body.style.overflow=''}
function doSrch(q){const r=$('sres');if(!q.trim()){r.innerHTML='';return}const hits=P.filter(p=>p.b.toLowerCase().includes(q.toLowerCase())||p.n.toLowerCase().includes(q.toLowerCase())).slice(0,5);r.innerHTML=hits.length?hits.map(p=>`<div class="sri" onclick="closeSrchOpen(${p.id})"><img src="${p.img}"><div><div class="sri-b">${p.b}</div><div class="sri-n">${p.n}</div><div class="sri-p">${fmt(p.price)}</div></div></div>`).join(''):`<div style="font-size:10px;color:rgba(237,233,227,.25);padding:10px 0">${lang==='en'?'No results.':'Keine Ergebnisse.'}</div>`}
function closeSrchOpen(id){toggleSrch();setTimeout(()=>openDrw(id),320)}

// ── Filter Panel ──────────────────────────────────────────────────────
function toggleFilter(){
  const p=$('filter-panel');
  p.classList.toggle('on');
  $('filter-btn').classList.toggle('active');
  document.body.style.overflow=p.classList.contains('on')?'hidden':'';
}
function fpBrand(val,el){
  brand=val;
  document.querySelectorAll('.fp-item[onclick*="fpBrand"]').forEach(i=>i.classList.remove('sel'));
  el.classList.add('sel');render();
}
function fpSort(val,el){
  if(val==='her'||val==='him'){gender=val;sort='';}
  else if(val===''){gender='';sort='';}
  else{sort=val;}
  document.querySelectorAll('.fp-item[onclick*="fpSort"]').forEach(i=>i.classList.remove('sel'));
  el.classList.add('sel');render();
}

// ── Toast & Keys ──────────────────────────────────────────────────────
let _t;
function toast(m){const el=$('tst');el.textContent=m;el.classList.add('on');clearTimeout(_t);_t=setTimeout(()=>el.classList.remove('on'),2400)}
document.addEventListener('keydown',e=>{if(e.key==='Escape'){['srch','drw','cart','filter-panel'].forEach(id=>{const el=$(id);if(el)el.classList.remove('on')});document.body.style.overflow='';document.querySelectorAll('.cdd-menu,.lang-menu').forEach(m=>m.classList.remove('open'))}});
document.addEventListener('click',e=>{
  if(!e.target.closest('.cdd-wrap'))document.querySelectorAll('.cdd-menu').forEach(m=>m.classList.remove('open'));
  if(!e.target.closest('.lang-wrap'))$('lang-menu').classList.remove('open');
});

render();

// ── Legal Popups ───────────────────────────────────────────────────────
const LEGAL = {
  impressum: {
    title: 'Impressum',
    html: `
      <h2>Angaben gemäß § 5 ECG</h2>
      <p><strong>ELYA</strong><br>Yassin El-Tahir<br>elyavision e.U.<br>Seitenstettengasse 5/37<br>1010 Wien, Österreich</p>
      <p><strong>Telefon:</strong> <a href="tel:+436766400342">+43 676 6400342</a><br>
      <strong>E-Mail:</strong> <a href="mailto:office@elya-aftersales.com">office@elya-aftersales.com</a></p>
      <h2>Unternehmensangaben</h2>
      <p><strong>Unternehmensgegenstand:</strong> Handel mit Sonnenbrillen und Accessoires</p>
      <p><strong>Gewerbebehörde:</strong> Magistrat der Stadt Wien</p>
      <p><strong>GISA-Zahl:</strong> 39472694</p>
      <p><strong>Gewerbe:</strong> Handelsgewerbe mit Ausnahme der reglementierten Handelsgewerbe und Handelsagent (freies Gewerbe)</p>
      <p><strong>Anwendbares Recht:</strong> Gewerbeordnung 1994 (GewO)</p>
      <h2>Haftungsausschluss</h2>
      <p>Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.</p>
      <h2>Urheberrecht</h2>
      <p>Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem österreichischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors.</p>
    `
  },
  datenschutz: {
    title: 'Datenschutzerklärung',
    html: `
      <h2>1. Datenschutz auf einen Blick</h2>
      <h3>Allgemeine Hinweise</h3>
      <p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen.</p>
      <h3>Verantwortliche Stelle</h3>
      <p><strong>ELYA — Yassin El-Tahir</strong><br>elyavision e.U.<br>Seitenstettengasse 5/37<br>1010 Wien, Österreich<br>
      <a href="mailto:office@elya-aftersales.com">office@elya-aftersales.com</a></p>
      <h2>2. Hosting</h2>
      <p>Diese Website wird bei Shopify Inc., Ottawa, Kanada gehostet. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer sicheren und effizienten Bereitstellung unseres Online-Angebots).</p>
      <h2>3. Datenerfassung</h2>
      <h3>Bestelldaten</h3>
      <p>Bei einer Bestellung verarbeiten wir Name, Adresse, E-Mail und Zahlungsdaten zur Abwicklung des Kaufvertrags (Art. 6 Abs. 1 lit. b DSGVO). Speicherdauer: gesetzliche Aufbewahrungspflicht (7 Jahre).</p>
      <h3>Kontaktaufnahme per E-Mail</h3>
      <p>Wenn Sie uns per E-Mail kontaktieren, werden Ihre Daten zur Bearbeitung der Anfrage gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</p>
      <h2>4. Ihre Rechte</h2>
      <p>Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung Ihrer gespeicherten personenbezogenen Daten sowie das Recht auf Datenübertragbarkeit. Wenden Sie sich an: <a href="mailto:office@elya-aftersales.com">office@elya-aftersales.com</a></p>
      <h2>5. Zahlungsdienstleister</h2>
      <p>Für die Zahlungsabwicklung nutzen wir Shopify Payments sowie externe Anbieter (Visa, Mastercard, PayPal, Klarna, Apple Pay). ELYA erhält keinen Zugriff auf Ihre vollständigen Zahlungsdaten.</p>
    `
  },
  versand: {
    title: 'Versand & Rückgabe',
    html: `
      <h2>Versand</h2>
      <h3>Liefergebiete</h3>
      <p>Wir liefern österreichweit sowie in ausgewählte EU-Länder. Für internationale Bestellungen außerhalb der EU kontaktiere uns vorab per E-Mail.</p>
      <h3>Versandzeiten</h3>
      <p>Bestellungen werden in der Regel innerhalb von <strong>1–2 Werktagen</strong> bearbeitet. Lieferzeit Österreich: <strong>2–4 Werktage</strong>, EU: <strong>4–7 Werktage</strong>.</p>
      <h3>Versandkosten</h3>
      <p>Innerhalb Österreichs ist der Versand <strong>kostenlos</strong> ab €100 Bestellwert. Darunter fallen €5,90 Versandkosten.</p>
      <h3>Verpackung</h3>
      <p>Jede Brille wird sorgfältig und diskret verpackt. Versicherter Versand ist ab €200 automatisch inbegriffen.</p>
      <h2>Rückgabe & Umtausch</h2>
      <h3>Widerrufsrecht</h3>
      <p>Du hast das Recht, binnen <strong>14 Tagen</strong> ohne Angabe von Gründen den Kaufvertrag zu widerrufen.</p>
      <h3>Rückgabevoraussetzungen</h3>
      <p>Artikel müssen sich im <strong>unbenutzten Originalzustand</strong> befinden — mit allen Etiketten, in der Originalverpackung inklusive Case und Putztuch.</p>
      <h3>Rückgabeprozess</h3>
      <p>Rückgabe einleiten per E-Mail an <a href="mailto:office@elya-aftersales.com">office@elya-aftersales.com</a> mit Bestellnummer und Grund. Wir melden uns innerhalb von 48 Stunden.</p>
      <h3>Rückerstattung</h3>
      <p>Nach Erhalt und Prüfung erstatten wir den Kaufpreis innerhalb von <strong>7–14 Werktagen</strong> auf das ursprüngliche Zahlungsmittel. Rücksendekosten trägt der Käufer, außer bei Defekten oder Falschlieferungen.</p>
      <h3>Preloved-Artikel</h3>
      <p>Für Preloved-Artikel gilt ein eingeschränktes Rückgaberecht. Gebrauchsspuren sind Teil des Produkts — bitte Zustandsbeschreibung vor dem Kauf genau lesen.</p>
      <h2>Authentizität</h2>
      <p>Sämtliche Brillen bei ELYA sind <strong>authentisch und geprüft</strong>. Bei begründetem Zweifel an der Echtheit erstatten wir den vollen Kaufpreis nach Rücksendung und eigener Prüfung.</p>
    `
  }
};

function openLegal(key) {
  const data = LEGAL[key];
  if (!data) return;
  document.getElementById('lm-title').textContent = data.title;
  document.getElementById('lm-body').innerHTML = data.html;
  const modal = document.getElementById('legal-modal');
  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';
  setTimeout(() => modal.style.opacity = '1', 10);
}

function closeLegal() {
  const modal = document.getElementById('legal-modal');
  modal.style.display = 'none';
  document.body.style.overflow = '';
}

// Close legal modal on Escape
document.addEventListener('keydown', e => {
  if (e.key === 'Escape' && document.getElementById('legal-modal').style.display !== 'none') closeLegal();
});
